import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { AlertRuleUpdateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { InputBoolean } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AlertRuleUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  alertType: string;
  alertTypeSelectedValue?: { displayId: string; id: string } | null;
  onAlertTypeChange?: (value: string) => void;
  alertTypeError?: string;
  enabled: boolean;
  enabledSelectedValue?: { displayId: string; id: string } | null;
  onEnabledChange?: (value: boolean) => void;
  enabledError?: string;
  params: string;
  paramsSelectedValue?: { displayId: string; id: string } | null;
  onParamsChange?: (value: string) => void;
  paramsError?: string;
  alertRuleUpdateStore: AlertRuleUpdateStore;
};

export const AlertRuleUpdateForm: React.FC<AlertRuleUpdateFormProps> = observer(
  ({
    onSave = () => {},
    onCancel = () => {},
    saving = false,
    showToolbox = true,
    showSaveFooter,
    alertType = "",
    alertTypeError,
    onAlertTypeChange = () => {},
    enabled = false,
    enabledError,
    onEnabledChange = () => {},
    params = "{}",
    paramsError,
    onParamsChange = () => {},
    alertRuleUpdateStore,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            saveAndCloseLabel={langStore.saveEntity}
            closeLabel={langStore.cancelUpdatedEntity}
            saveForm={() => onSave()}
            saveDisabled={saving}
            closeForm={() => onCancel()}
          />
        )}
        <Box>
          <FormExtras
            entity="AlertRule"
            mode="update"
            values={{}}
            options={{}}
            onPatch={(campo: string, valor: any) => {
              switch (campo) {
                case "alertType":
                  onAlertTypeChange?.(valor);
                  break;
                case "enabled":
                  onEnabledChange?.(valor);
                  break;
                case "params":
                  onParamsChange?.(valor);
                  break;
              }
            }}
          />
          <GroupContainer
            id="null"
            errorText={alertRuleUpdateStore.getCardErrors("null")}
            title={langStore.groupAlertRuleLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <InputString
                autoFocus
                value={alertType}
                error={Boolean(alertTypeError)}
                warning={
                  !alertTypeError &&
                  Boolean(alertRuleUpdateStore.warnings["alertType"])
                }
                helperText={
                  alertTypeError ||
                  alertRuleUpdateStore.warnings["alertType"]?.message
                }
                label={langStore.AlertRuleAlertTypeLabel}
                onChange={(value: string) => onAlertTypeChange(value)}
                description={langStore.AlertRuleAlertTypeDescription}
              />
              <InputBoolean
                value={enabled}
                error={Boolean(enabledError)}
                helperText={
                  enabledError ||
                  alertRuleUpdateStore.warnings["enabled"]?.message
                }
                label={langStore.AlertRuleEnabledLabel}
                onChange={(value: boolean) => onEnabledChange(value)}
              />
              <InputCodeEditor
                value={params}
                error={Boolean(paramsError)}
                helperText={
                  paramsError ||
                  alertRuleUpdateStore.warnings["params"]?.message
                }
                label={langStore.AlertRuleParamsLabel}
                onChange={(value: string) => onParamsChange(value)}
                language="json"
                description={langStore.AlertRuleParamsDescription}
              />
            </FormControl>
          </GroupContainer>
        </Box>
        {(showSaveFooter ?? !showToolbox) && (
          <FormSaveFooter
            onSave={() => onSave()}
            label={langStore.saveEntity}
            disabled={saving}
          />
        )}
      </Grid>
    );
  }
);
